export enum VIDEOS_AND_EVENTS_CATEGORIES {
  LIVE_TRANSMISSIONS = '275'
}

export const LIVE_TRANSMISSIONS_CATEGORY_IDS = [
  VIDEOS_AND_EVENTS_CATEGORIES.LIVE_TRANSMISSIONS,
  '8A9481DB948B377001954874AE514CED'
];
